import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatDialogModule } from '@angular/material/dialog';
import { AuthComponent } from './components/auth-modal/auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { LetDirective } from '@ngrx/component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslatePipe } from '../../pipes/translate.pipe';
// Standalone date-of-birth picker reused from the profile form — keeps
// the UX identical between signup and "edit profile" so admins see the
// same value shape in both places.
import { DateOfBirthPickerComponent } from '../../shared/components/date-of-birth-picker/date-of-birth-picker.component';

@NgModule({
  declarations: [AuthComponent],
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatProgressSpinner,
    MatButtonModule,
    MatSelectModule,
    LetDirective,
    TranslatePipe,
    DateOfBirthPickerComponent,
  ],
  exports: [AuthComponent],
})
export class AuthModule {}
